var $ = require('jquery');

// Toggle Search bar
$('.header__search').click(function (){
  $('.header').toggleClass('search--open');
  $('.header__searchbar input').select();
})


$('.header__mobile__trigger').click(function (){
  $('.header').toggleClass('menu--open');
})

